export default "__VITE_ASSET__3sykp3ff__"